/*!
 * angular-translate - v2.7.2 - 2015-06-01
 * http://github.com/angular-translate/angular-translate
 * Copyright (c) 2015 ; Licensed MIT
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module unless amdModuleId is set
        define([], function () {
            return (factory());
        });
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        factory();
    }
}(this, function () {

    angular.module('pascalprecht.translate')
    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateStaticFilesLoader
     * @requires $q
     * @requires $http
     *
     * @description
     * Creates a loading function for a typical static file url pattern:
     * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
     * the response of these urls must be an object of key-value pairs.
     *
     * @param {object} options Options object, which gets prefix, suffix and key.
     */
    .factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

    function $translateStaticFilesLoader($q, $http) {

        'use strict';

        return function (options) {

            if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
                throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
            }

            if (!options.files) {
                options.files = [{
                    prefix: options.prefix,
                    suffix: options.suffix
                }];
            }

            var load = function (file) {
                if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
                    throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
                }

                var deferred = $q.defer();

                $http(angular.extend({
                    url: [
                      file.prefix,
                      options.key,
                      file.suffix
                    ].join(''),
                    method: 'GET',
                    params: ''
                }, options.$http)).success(function (data) {
                    deferred.resolve(data);
                }).error(function () {
                    deferred.reject(options.key);
                });

                return deferred.promise;
            };

            var deferred = $q.defer(),
                promises = [],
                length = options.files.length;

            for (var i = 0; i < length; i++) {
                promises.push(load({
                    prefix: options.files[i].prefix,
                    key: options.key,
                    suffix: options.files[i].suffix
                }));
            }

            $q.all(promises).then(function (data) {
                var length = data.length,
                    mergedData = {};

                for (var i = 0; i < length; i++) {
                    for (var key in data[i]) {
                        mergedData[key] = data[i][key];
                    }
                }

                deferred.resolve(mergedData);
            }, function (data) {
                deferred.reject(data);
            });

            return deferred.promise;
        };
    }
    $translateStaticFilesLoader.$inject = ['$q', '$http'];

    $translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
    return 'pascalprecht.translate';

}));